import { render } from "./ContactsEditor.vue?vue&type=template&id=4b1643db&ts=true"
import script from "./ContactsEditor.vue?vue&type=script&lang=ts"
export * from "./ContactsEditor.vue?vue&type=script&lang=ts"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../../ss/MS/ui/NibrsRepository/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__